import { useState, useRef } from 'react';
import SiteNavBar from '../../components/feature/SiteNavBar';
import SiteFooter from '../../components/feature/SiteFooter';
import { propertyData } from '../../mocks/property';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { useTranslation } from 'react-i18next';

export default function KontaktPage() {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const formRef = useRef<HTMLFormElement>(null);
  const { ref: refLeft, isVisible: visLeft } = useScrollReveal();
  const { ref: refRight, isVisible: visRight } = useScrollReveal();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (charCount > 500) return;
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => { data.append(key, value.toString()); });
    try {
      await fetch('https://readdy.ai/api/form/d705lel1l1ubpb129of0', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: data.toString() });
      setSubmitted(true);
    } catch { setSubmitted(true); } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF7]">
      <SiteNavBar />
      <section className="relative h-72 flex items-end pb-14 overflow-hidden">
        <img src="https://public.readdy.ai/ai/img_res/21dba362b30f82772c91e1b84573264e.jpg" alt="Kontakt Hero" className="absolute inset-0 w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/20" />
        <div className="relative z-10 max-w-7xl mx-auto px-8 w-full">
          <p className="font-sans text-[10px] tracking-[0.35em] uppercase text-[#B59A6A] mb-3">The Obsidian Villa</p>
          <h1 className="font-serif text-4xl md:text-5xl font-medium text-white">{t('contact.label')}</h1>
        </div>
      </section>

      <section className="py-20 bg-[#FAFAF7]">
        <div className="max-w-7xl mx-auto px-8 text-center max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="gold-line" />
            <p className="font-sans text-[10px] tracking-[0.35em] uppercase text-[#B59A6A]">{t('contact.viewingLabel')}</p>
            <div className="gold-line" />
          </div>
          <h2 className="font-serif text-4xl font-medium text-[#1C1C1C] mb-5 max-w-xl mx-auto leading-snug">{t('contact.heading')}</h2>
          <p className="font-sans text-sm text-[#6B6460] font-light leading-loose max-w-lg mx-auto">{t('contact.introSub')}</p>
        </div>
      </section>

      <section className="pb-24 bg-[#FAFAF7]">
        <div className="max-w-7xl mx-auto px-8">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">
            <div ref={refLeft} className={`lg:col-span-3 reveal-left ${visLeft ? 'visible' : ''}`}>
              {submitted ? (
                <div className="flex flex-col items-start min-h-[420px] justify-center py-12 border border-[#E5DDD3] px-10">
                  <div className="w-12 h-px bg-[#B59A6A] mb-8" />
                  <h3 className="font-serif text-3xl text-[#1C1C1C] mb-4">{t('contact.thanks')}</h3>
                  <p className="font-sans text-sm text-[#6B6460] font-light leading-loose max-w-sm">{t('contact.thanksText')}</p>
                </div>
              ) : (
                <form ref={formRef} data-readdy-form id="kontakt-page-form" onSubmit={handleSubmit} className="space-y-8 border border-[#E5DDD3] p-10 bg-white">
                  <div><p className="font-serif text-xl text-[#1C1C1C] mb-8">{t('contact.formTitle')}</p></div>
                  <div className="grid grid-cols-2 gap-6">
                    <div>
                      <label className="block font-sans text-[10px] tracking-[0.2em] uppercase text-[#6B6460] mb-2">{t('contact.firstName')}</label>
                      <input type="text" name="vorname" required placeholder={t('contact.firstNamePh')} className="w-full bg-transparent border-b border-[#E5DDD3] focus:border-[#B59A6A] outline-none py-3 font-sans text-sm text-[#1C1C1C] placeholder-[#BFBAB5] transition-colors" />
                    </div>
                    <div>
                      <label className="block font-sans text-[10px] tracking-[0.2em] uppercase text-[#6B6460] mb-2">{t('contact.lastName')}</label>
                      <input type="text" name="nachname" required placeholder={t('contact.lastNamePh')} className="w-full bg-transparent border-b border-[#E5DDD3] focus:border-[#B59A6A] outline-none py-3 font-sans text-sm text-[#1C1C1C] placeholder-[#BFBAB5] transition-colors" />
                    </div>
                  </div>
                  <div>
                    <label className="block font-sans text-[10px] tracking-[0.2em] uppercase text-[#6B6460] mb-2">{t('contact.email')}</label>
                    <input type="email" name="email" required placeholder={t('contact.emailPh')} className="w-full bg-transparent border-b border-[#E5DDD3] focus:border-[#B59A6A] outline-none py-3 font-sans text-sm text-[#1C1C1C] placeholder-[#BFBAB5] transition-colors" />
                  </div>
                  <div>
                    <label className="block font-sans text-[10px] tracking-[0.2em] uppercase text-[#6B6460] mb-2">{t('contact.phone')}</label>
                    <input type="tel" name="telefon" placeholder={t('contact.phonePh')} className="w-full bg-transparent border-b border-[#E5DDD3] focus:border-[#B59A6A] outline-none py-3 font-sans text-sm text-[#1C1C1C] placeholder-[#BFBAB5] transition-colors" />
                  </div>
                  <div>
                    <label className="block font-sans text-[10px] tracking-[0.2em] uppercase text-[#6B6460] mb-2">{t('contact.concern')}</label>
                    <select name="anliegen" className="w-full bg-transparent border-b border-[#E5DDD3] focus:border-[#B59A6A] outline-none py-3 font-sans text-sm text-[#1C1C1C] transition-colors cursor-pointer">
                      <option value="Besichtigung">{t('contact.optViewing')}</option>
                      <option value="Grundriss">{t('contact.optFloorplan')}</option>
                      <option value="Informationen">{t('contact.optInfo')}</option>
                      <option value="Preisanfrage">{t('contact.optPrice')}</option>
                    </select>
                  </div>
                  <div>
                    <label className="block font-sans text-[10px] tracking-[0.2em] uppercase text-[#6B6460] mb-2">{t('contact.message')}</label>
                    <textarea name="nachricht" maxLength={500} rows={4} onChange={(e) => setCharCount(e.target.value.length)} placeholder={t('contact.messagePh')} className="w-full bg-transparent border-b border-[#E5DDD3] focus:border-[#B59A6A] outline-none py-3 font-sans text-sm text-[#1C1C1C] placeholder-[#BFBAB5] transition-colors resize-none" />
                    <p className={`font-sans text-[10px] mt-1 text-right ${charCount > 450 ? 'text-red-400' : 'text-[#BFBAB5]'}`}>{charCount}/500</p>
                  </div>
                  <div className="pt-2">
                    <button type="submit" disabled={submitting || charCount > 500} className="gold-btn w-full text-center disabled:opacity-50 cursor-pointer">
                      {submitting ? t('contact.sending') : t('contact.send')}
                    </button>
                    <p className="font-sans text-[10px] text-[#BFBAB5] text-center mt-4">{t('contact.discrete')}</p>
                  </div>
                </form>
              )}
            </div>

            <div ref={refRight} className={`lg:col-span-2 reveal-right ${visRight ? 'visible' : ''} flex flex-col gap-6`}>
              <div className="border border-[#E5DDD3] bg-white overflow-hidden">
                <div className="w-full h-60 overflow-hidden">
                  <img src={propertyData.agent.photo} alt={propertyData.agent.name} className="w-full h-full object-cover object-top" />
                </div>
                <div className="p-8">
                  <div className="w-8 h-px bg-[#B59A6A] mb-4" />
                  <h3 className="font-serif text-xl font-medium text-[#1C1C1C] mb-1">{propertyData.agent.name}</h3>
                  <p className="font-sans text-[10px] tracking-widest uppercase text-[#B59A6A] mb-6">{propertyData.agent.title}</p>
                  <div className="space-y-3">
                    <a href={`tel:${propertyData.agent.phone}`} className="flex items-center gap-3 group cursor-pointer">
                      <div className="w-6 h-6 flex items-center justify-center"><i className="ri-phone-line text-[#B59A6A] text-sm" /></div>
                      <span className="font-sans text-sm text-[#1C1C1C] group-hover:text-[#B59A6A] transition-colors">{propertyData.agent.phone}</span>
                    </a>
                    <a href={`mailto:${propertyData.agent.email}`} className="flex items-center gap-3 group cursor-pointer">
                      <div className="w-6 h-6 flex items-center justify-center"><i className="ri-mail-line text-[#B59A6A] text-sm" /></div>
                      <span className="font-sans text-[13px] text-[#1C1C1C] group-hover:text-[#B59A6A] transition-colors">{propertyData.agent.email}</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="border border-[#E5DDD3] bg-white p-8">
                <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#B59A6A] mb-5">{t('contact.office')}</p>
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center mt-0.5"><i className="ri-map-pin-line text-[#B59A6A] text-sm" /></div>
                    <div>
                      <p className="font-sans text-sm text-[#1C1C1C] font-light">Bahnhofstrasse 12</p>
                      <p className="font-sans text-sm text-[#1C1C1C] font-light">8001 Zürich</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-6 h-6 flex items-center justify-center"><i className="ri-time-line text-[#B59A6A] text-sm" /></div>
                    <p className="font-sans text-sm text-[#1C1C1C] font-light">{t('contact.hours')}</p>
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3 px-1">
                <i className="ri-shield-check-line text-[#B59A6A] text-sm mt-0.5" />
                <p className="font-sans text-[11px] text-[#6B6460] font-light leading-relaxed">{t('contact.discreteFull')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
